/**
 * Build filter for string using a given orderByValue and date strings array.
 *
 * @param orderByValue string
 * @param dateStrings string[][]
 * @returns string
 */
export default (orderByValue: string, dashboardDateStrings: string[][]): string => {
  if (!orderByValue || !dashboardDateStrings?.every(arr => arr[0])) return '';

  return `${orderByValue} ${dashboardDateStrings[0]} ${orderByValue} ${dashboardDateStrings[1]}`;
};
